import { render, staticRenderFns } from "./FormResponseType6.vue?vue&type=template&id=6834607b&scoped=true&"
import script from "./FormResponseType6.vue?vue&type=script&lang=js&"
export * from "./FormResponseType6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6834607b",
  null
  
)

export default component.exports